import React from 'react';

import 'datatables.net-responsive-dt';
import loading from "./../../assets/images/loading-new.gif";

import 'jquery/dist/jquery.min.js';
import { Link } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

//Datatable Modules
import { ArrowLongLeftIcon } from '@heroicons/react/24/solid';
import ActiveUser from './ActiveUser';
import DisabledUser from './DisabledUser';

const Users = () => {

    return (

        <div style={{ position: "relative" }} className="rewardRequest">

            <Link to="/admin" className='admin-header'>
                <ArrowLongLeftIcon className="" style={{ width: '30px' }} />
                <p style={{ marginBottom: '0' }} >User Management</p>
            </Link>


            <div id='loader' style={{ display: "none", position: "fixed", top: "50%", left: "55%", transform: "translate(-50%,-50%)", zIndex: "1" }}>
                <img src={loading} alt="loading..." />
            </div>
            <link rel="stylesheet" href="https://cdn.datatables.net/1.13.3/css/jquery.dataTables.css"></link>

            <div style={{ marginTop: "40px", backgroundColor: "white", padding: "20px", borderRadius: "8px" }}>
                <p style={{ marginBottom: '20px', fontSize: "18px", color: "black", fontWeight: "600", fontFamily: "Poppins" }}>User List</p>
                <Tabs>
                    <TabList>
                        <Tab>Active</Tab>
                        <Tab>Disabled</Tab>
                    </TabList>

                    <div className="profile-pp-wrap">
                        <TabPanel>
                            <ActiveUser />
                        </TabPanel>
                        <TabPanel>
                            <DisabledUser />
                        </TabPanel>

                    </div>
                    {/*Pats Posts[pp]-----END*/}
                </Tabs>
            </div>

            {/* componentDidMount() {
                $('#myTable').DataTable()
            } */}


        </div>
    )
};

export default Users